import { useSelector } from 'react-redux';
import { ReduxState } from '../store';

export function useSelectedTemplateId(): number | undefined {
  return useSelector((state: ReduxState) => state.userReducer.selectedTemplateId);
}
